window.onload = load

function load() {
	loadGoogleFonts()
	attachVideoEvents()
	attachMainMenuEvents()
}

/**
 *
 */
function attachVideoEvents() {
	const $videos = document.querySelectorAll('.demo video')
	$videos.forEach($video => {
		$video.addEventListener('mouseover', () => {
			$video.parentElement.classList.add('isPlaying')
			$video.play()
		})

		$video.addEventListener('mouseout', () => {
			$video.parentElement.classList.remove('isPlaying')
			$video.pause()
		})

		$video.addEventListener('loadeddata', () => {
			$video.parentElement.classList.add('loaded')
		}, false)
	})
}

/**
 *
 */
function attachMainMenuEvents() {
	const $mobileMenuTrigger = document.querySelector('#mobile-menu-trigger')
	const $menu = document.querySelector('#menu')
	$mobileMenuTrigger.addEventListener('click', () => {
		$mobileMenuTrigger.classList.toggle('visible')
		$menu.classList.toggle('visible')
	})
}

/**
 *
 */
function loadGoogleFonts() {
	const head = document.getElementsByTagName('head')[0]
	const el = document.createElement('link')
	el.rel = 'stylesheet'
	el.href = 'https://fonts.googleapis.com/css?family=Oswald:300,400,500,700%7CSource+Sans+Pro:400,400i,600,600i&subset=latin&display=block'
	head.appendChild(el)
}

/**
 *
 * @param x
 * @param y
 */
function initColorSphereBackground(x, y) {
	new ColorSphereBackground([
		{
			element: document.querySelector("header .clearfix"),
			height: 10,
			x,
			y
		},
		{
			element: document.querySelector("#footer"),
			x,
			y
		}
	])
}

/**
 *
 * @param params
 * @constructor
 */
function ColorSphereBackground(params) {
	/**
	 *
	 * @param {Object} input
	 */
	function createRibbon(input) {
		var $parent = input.element
		input.x = input.x || 0
		input.y = input.y || 0
		input.width = input.width || Math.max(window.innerWidth, $parent.offsetWidth)
		input.height = input.height || $parent.offsetHeight || window.innerHeight

		var $canvas = document.createElement('canvas')
		var ctx = $canvas.getContext('2d')
		$canvas.style.cssText = 'position: absolute; left: 0; top: 0; opacity: 1; z-index: 0'
		$canvas.style.width = '100%'
		$canvas.style.height = input.height + 'px'
		$parent.appendChild($canvas)

		var $sphere = sphere(input, $canvas)
		ctx.drawImage($sphere, 0, 0)

		var x = input.x
		var y = input.y
		var imageData = ctx.getImageData(0, 0, $canvas.width, $canvas.height); // get image data
		var data = imageData.data
		for (var i = 0, length = data.length; i < length; i += 4) {
			data[i] = data[i] + x - y // red (control left)
			data[i + 1] = data[i + 1] - x - y // green (control right)
			data[i + 2] = data[i + 2] + y + y // blue (control down)
		}
		ctx.putImageData(imageData, 0, 0)
	}

	/**
	 *
	 * @param {Object} input
	 * @param {HTMLCanvasElement} $canvas
	 * @return {HTMLCanvasElement}
	 */
	function sphere(input, $canvas) {
		var $sphere = document.createElement('canvas')
		var ctx = $sphere.getContext('2d')
		var height = 50
		var width = 60
		var left = -height / 2.0
		var top = -height

		$canvas.width = $sphere.width = width
		$canvas.height = $sphere.height = height

		ctx.fillRect(0, 0, window.innerWidth, window.innerHeight)

		var i = 360
		while (i--) { // go through hues
			var x = left + height
			var y = top + height * 2
			var g = ctx.createLinearGradient(x, top, x, y)
			g.addColorStop(0, 'rgba(0,0,0,0)')
			g.addColorStop(.5, 'hsl(' + ((i + 60) % 360) + ',100%,50%)')
			g.addColorStop(1, '#FFF')
			ctx.beginPath(); // draw triangle
			ctx.moveTo(x, top)
			ctx.lineTo(x, y)
			ctx.lineTo(x + 2, y)
			ctx.lineTo(x + 5, top)
			ctx.fillStyle = g
			ctx.fill()
			ctx.translate(x, y)
			ctx.rotate((1 / 360) * Math.PI * 2)
			ctx.translate(-x, -y)
		}

		return $sphere
	}

	for (var i = 0; i < params.length; i++) {
		createRibbon(params[i])
	}
}
